import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { ChevronRight, Briefcase } from "lucide-react";

const STATUS = {
  submitted:    { label: "Received — under review", color: "#a6adc8" },
  shortlisted: { label: "Shortlisted",              color: "#d4b876" },
  selected:     { label: "Selected — congratulations", color: "#89b4fa" },
  not_selected: { label: "Not selected",             color: "#7f849c" },
  withdrawn:    { label: "Withdrawn",                color: "#7f849c" },
};

export default function CareersMine() {
  const [apps, setApps] = useState([]);
  useEffect(() => {
    api.get("/hrm/applications/mine").then(r => setApps(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-[1000px] mx-auto px-6 py-10">
      <div className="label-mono">Careers</div>
      <h1 className="font-display text-4xl mt-2 leading-tight">My applications</h1>
      <p className="text-white/55 text-sm mt-3 max-w-xl leading-relaxed">
        The status of every application you've submitted through this portal. HR updates each one as
        the selection process runs.
      </p>

      <div className="mt-10">
        {apps.length === 0 ? (
          <div className="border border-white/8 bg-white/[0.015] p-10 text-center">
            <div className="font-display text-xl">You haven't applied to anything yet.</div>
            <Link to="/careers" className="btn-cta primary text-xs mt-6"><Briefcase size={12}/> Browse open positions</Link>
          </div>
        ) : (
          <div className="space-y-3" data-testid="my-apps-list">
            {apps.map(a => {
              const st = STATUS[a.status] || { label: a.status, color: "#a6adc8" };
              return (
                <Link key={a.id} to={`/careers/${a.posting_id}`}
                  className="block border border-white/8 bg-white/[0.015] p-5 hover:border-[color:var(--cobalt)]/50"
                  data-testid={`my-app-${a.id}`}>
                  <div className="flex justify-between items-center flex-wrap gap-3">
                    <div className="min-w-0">
                      <div className="font-display text-xl">{a.posting_title}</div>
                      <div className="font-mono text-[10px] text-white/50 uppercase tracking-widest mt-1">
                        submitted {new Date(a.submitted_at).toLocaleDateString()}
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <span className="tag" style={{color: st.color}}>{st.label}</span>
                      <ChevronRight size={14} className="text-white/30"/>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
